import IUser from "Types/User";

const jsonwebtoken = require("jsonwebtoken");

export function isLogged(login: any) {
	const { token, user } = login;

	if (token) {
		const decodedToken = jsonwebtoken.decode(token, { complete: true });

		if (
			decodedToken &&
			user &&
			decodedToken.payload[
				"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
			] === user.id
		) {
			return true;
		}
	}
	return false;
}

export const isInRole = (user: IUser, roles: string[] = []) => {
	if (!user) return false;

	if (!user.roles) return false;

	return Boolean(
		user.roles.find(c => roles.find(r => r.toLowerCase() === c.toLowerCase()))
	);
};
